import React, { useEffect, useRef } from "react";
import { faBus, faHotel, faMoneyBillWave, faPassport, faPlane, faShieldAlt, faSuitcaseRolling, faTaxi } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useLocation } from "react-router-dom";
import ScrollToTop from "../components/ScrollToTop";
import HelmetComponent from "../components/Helmet";
const Services = () => {
  const location = useLocation();
  const serviceSection = useRef(null);
  useEffect(() => {
    if (serviceSection.current) {
      serviceSection.current.scrollIntoView({ behavior: "auto" });
    }
  }, []);

  const services = [
    {
      title: "Flights",
      icon: faPlane,
      desc: "Hassle-free domestic and international flight bookings at best prices.",
      key: "FlightBooking",
      message: "Hi, I want to book flight tickets. Please share best fares and options."
    },
    {
      title: "Hotels",
      icon: faHotel,
      desc: "Luxury, budget & boutique hotel options for a comfortable stay.",
      key: "HotelBooking",
      message: "Hi, I need hotel booking options. Please share best deals and availability."
    },
    {
      title: "Packages",
      icon: faSuitcaseRolling,
      desc: "Customized holiday packages for couples, families & solo travelers.",
      key: "HolidayPackage",
      message: "Hi, I am looking for a holiday package. Please share best options and pricing."
    },
    {
      title: "Insurance",
      icon: faShieldAlt,
      desc: "Travel insurance for a safe and worry-free journey.",
      key: "TravelInsurance",
      message: "Hi, I need travel insurance. Please share plans and pricing."
    },
    {
      title: "Visa",
      icon: faPassport,
      desc: "Fast and smooth visa assistance for international travel.",
      key: "VisaService",
      message: "Hi, I need visa assistance. Please guide me with process and charges."
    },
    {
      title: "Bus",
      icon: faBus,
      desc: "Comfortable bus bookings for group and individual travel.",
      key: "BusBooking",
      message: "Hi, I want to book bus tickets. Please share available options."
    },
    {
      title: "Cabs",
      icon: faTaxi,
      desc: "Private cabs and chauffeur-driven services for easy travel.",
      key: "CabBooking",
      message: "Hi, I need cab service. Please share pricing and availability."
    },
    {
      title: "Forex",
      icon: faMoneyBillWave,
      desc: "Easy and reliable currency exchange services.",
      key: "ForexExchange",
      message: "Hi, I need forex exchange. Please share rates and details."
    },
  ];
  return (
    <>
      {location.pathname === "/services" && (
        <HelmetComponent
          title="Travel Services | Flights, Hotels, Visas & Tour Packages"
          description="Explore travel services by Shri Radhe Holidays including flights, hotel bookings, honeymoon packages, visa assistance, travel insurance and customized holidays."
          url="https://www.shriradheholidays.com/services"
        />

      )}

      <div className="max-lg:px-4 lg:px-5 xl:px-5 py-4 scroll-mt-[60px]" ref={serviceSection} >
        <div className="">
          <div className={`mt-6 max-lg:mx-2 mx-2 text-start border-l-8 rounded-r-full bg-[#0B1C3D]  border-[#D4AF37] wow fadeInUp max-sm:w-[70%] xl:w-[50%] transform -skew-x-12`} data-wow-delay="0.1s"
            style={{ boxShadow: ' 0px 0px 20px 5px  rgb(0 0 0 / 32%)' }}
          >
            {/* Heading */}
            <h1 className=" playfair-display font-extrabold py-[6px] px-2 max-lg:text-xl text-2xl text-white">
              Services
            </h1>
            {/* <h6  className="mb-5">Our Services</h6> */}
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 mt-5">
            {services.map((item, index) => (
              <div
                key={index}
                className="card-service flex flex-col w-full"
                style={{ boxShadow: ' 0px 0px 20px 5px  rgb(0 0 0 / 32%)' }}
              >
                <div className="flex items-center gap-3">
                  <FontAwesomeIcon
                    icon={item.icon}
                    className="h-[28px] text-[#D4AF37]"
                  />
                  <h1 className="text-base sm:text-lg md:text-lg lg:text-[18px] font-semibold hanuman-regular">
                    {item.title}
                  </h1>
                </div>

                <p className=" max-sm:text-[16px] md:text-sm lg:text-[14px] mt-2 opacity-80 poppins leading-relaxed">
                  {item.desc}
                </p>
                <div className="flex justify-start "> {/* Container alignment adjust karein */}
                  <a
                    href={`https://wa.me/919560070953?text=${encodeURIComponent(item.message)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="no-underline "
                  >
                    <button
                      type="submit"
                      className="
                 relative z-10 overflow-hidden group flex items-center justify-start gap-2 
             rounded-r-full  shadow-xl isolation-auto transition-all duration-700 
             
             /* Colors */
             bg-[#D4AF37] text-[#ffffff] hover:text-gray-50
             
             /* Responsive Sizing (Mobile first) */
             px-3 py-2 text-sm           /* Default: Mobile */
             sm:px-6 sm:py-3 sm:text-sm /* Tablets */
             lg:px-8 lg:py-3 lg:text-sm   /* Desktop */
             lg:font-semibold
             
             /* Hover Effect Logic */
             before:absolute before:w-full before:transition-all before:duration-700 
             before:-left-full before:hover:left-0 before:rounded-full before:bg-[#0B1C3D] 
             before:-z-10 before:aspect-square before:hover:scale-150
             "
                    >
                      <span className="whitespace-nowrap">Get {item.title} Quote</span>
                      <svg
                        className="
                                                        shrink-0 ease-linear duration-300 rounded-full border border-[#0B1C3D] p-2 rotate-45
                                                        
                                                        /* Responsive Icon Size */
                                                        w-6 h-6   /* Mobile */
                                                        sm:w-7 sm:h-7 /* Tablet/Desktop */
                                                        
                                                        /* Hover States */
                                                        group-hover:rotate-90 group-hover:bg-gray-50 group-hover:border-none
                                                    "
                        viewBox="0 0 16 19"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7 18C7 18.5523 7.44772 19 8 19C8.55228 19 9 18.5523 9 18H7ZM8.70711 0.292893C8.31658 -0.0976311 7.68342 -0.0976311 7.29289 0.292893L0.928932 6.65685C0.538408 7.04738 0.538408 7.68054 0.928932 8.07107C1.31946 8.46159 1.95262 8.46159 2.34315 8.07107L8 2.41421L13.6569 8.07107C14.0474 8.46159 14.6805 8.46159 15.0711 8.07107C15.4616 7.68054 15.4616 7.04738 15.0711 6.65685L8.70711 0.292893ZM9 18L9 1H7L7 18H9Z"
                          className="fill-[#0B1C3D]"
                        ></path>
                      </svg>
                    </button>
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <ScrollToTop />
    </>
  );
};

export default Services;
